import { useTranslation } from 'react-i18next';
import { Eye, X } from 'lucide-react';
import { useAuthStore } from '@/store/authStore';

/**
 * Sticky banner shown to a SuperAdmin while their view is scoped to a tenant
 * (header TenantSwitcher / "View as Tenant"). Makes the active tenant obvious
 * and gives a one-click way back to the global SuperAdmin view.
 */
export function ImpersonationBanner() {
  const { t } = useTranslation();
  const role = useAuthStore((s) => s.role);
  const impersonatedTenantId = useAuthStore((s) => s.impersonatedTenantId);
  const impersonatedTenantName = useAuthStore((s) => s.impersonatedTenantName);
  const setImpersonatedTenant = useAuthStore((s) => s.setImpersonatedTenant);

  if (role !== 'superadmin' || impersonatedTenantId === null) return null;

  const name = impersonatedTenantName || `#${impersonatedTenantId}`;

  return (
    <div className="flex items-center justify-between gap-3 border-b border-primary bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground shadow-sm" role="status">
      <span className="flex items-center gap-2">
        <Eye className="h-4 w-4 shrink-0" />
        {t('layout.impersonationBanner.viewing', { name })}
      </span>
      <button
        type="button"
        onClick={() => setImpersonatedTenant(null)}
        className="flex items-center gap-1 rounded-md border border-primary-foreground/40 bg-primary-foreground/10 px-3 py-1 transition-colors hover:bg-primary-foreground/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-foreground"
        aria-label={t('layout.impersonationBanner.exit')}
      >
        <X className="h-4 w-4" />
        {t('layout.impersonationBanner.exit')}
      </button>
    </div>
  );
}
